<template>
  <section class="product-item-card" :style="{ left: productCard.position.left + 'vw' }">
    <div class="product-item-card__header">
      <h1 class="font product-item-card__header__title">{{ productCard.name }}</h1>
      <svg
        id="Layer_1"
        class="product-item-card__header__close"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 14.92 14.92"
        @click="close(productCard.parentId)"
      >
        <title>close</title>
        <g class="cls-1">
          <line class="cls-2" x1="13.92" y1="1" x2="1" y2="13.92" />
          <line class="cls-2" x1="13.92" y1="13.92" x2="1" y2="1" />
        </g>
      </svg>
    </div>
    <div class="product-item-card__body">
      <div class="product-item-card__body__info-box">
        <div class="product-item-card__body__info-box__text">
          <p class="font">{{ productCard.description }}</p>
        </div>
      </div>
      <div class="product-item-card__body__img-box">
        <img :src="getImage(productCard.imageTwo)" alt />
      </div>
      <div class="product-item-card__body__bullets">
        <div
          v-for="(bullet, i) in productCard.bullets"
          :key="i"
          class="product-item-card__body__bullets__line"
        >
          <p class="product-item-card__body__bullets__line__text font--semibold">{{ bullet.name }}</p>
          <div class="product-item-card__body__panel">
            <p
              v-if="bullet.description"
              class="font product-item-card__body__panel__description"
            >{{bullet.description}}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  name: "product-item-card",
  props: ["productCard"],

  methods: {
    ...mapMutations([
      "updateShowButtons",
      "updatePreviousProductId",
      "updateIsActive",
      "updateCurrentProductId",
      "updateShowAmbientAnimations"
    ]),
    ...mapActions(["removeFirstProductCard", "removeProductIconsToReveal"]),
    close(id) {
      this.updateShowAmbientAnimations(true);
      this.updateShowButtons(true);
      this.removeFirstProductCard();
      this.removeProductIconsToReveal(id);
      this.updatePreviousProductId(null);
      this.updateCurrentProductId(null);
    },
    getImage(pic) {
      if (pic) {
        var image = require.context("@/assets/product-bar-assets/", false);
        return image("./" + pic);
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "../styles/_vars";

.product-item-card {
  position: absolute;
  bottom: 1.5vw;
  background-color: $color-white;
  width: 16vw;
  height: auto;
  @media screen and (max-aspect-ratio: 256/135) {
    bottom: 3.5vw;
    width: 16vw;
    height: auto;
  }
  &__header {
    height: 5vh;
    width: 100%;
    background-color: black;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    &__title {
      margin-left: 0.5vw;
      color: $color-white;
      font-size: 0.6vw;
      @media screen and (max-aspect-ratio: 256/135) {
        font-size: 0.8vw;
      }
    }
    &__close {
      cursor: pointer;
      width: 0.4vw;
      height: 0.4vw;
      margin-right: 0.5vw;
      @media screen and (max-aspect-ratio: 256/135) {
        width: 0.6vw;
        height: 0.6vw;
      }
      .cls-1 {
        opacity: 0.6;
      }
      .cls-2 {
        fill: none;
        stroke: $color-white;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 2px;
      }
    }
  }
  &__body {
    padding: 0.5vw;
    &__info-box {
      width: 100%;
      padding-bottom: 0.5vw;
      &__text {
        font-size: 0.57vw;
        line-height: 0.9vw;
        @media screen and (max-aspect-ratio: 256/135) {
          font-size: 0.65vw;
          line-height: 1vw;
        }
      }
    }
    &__panel {
      margin: 0.2vh 0 0.2vh 01vw;
      &__description {
        font-size: 0.57vw;
        line-height: 0.9vw;
      }
    }
    .clickable {
      cursor: pointer;
    }

    &__img-box {
      width: 100%;
      padding-bottom: 0.5vw;
      img {
        width: 100%;
      }
    }
    &__bullets {
      &__line {
        &__text {
          margin-left: 0.2vw;
          font-size: 0.55vw;
          color: $color-torquoise;
          @media screen and (max-aspect-ratio: 256/135) {
            font-size: 0.65vw;
          }
        }
      }
    }
  }
}
</style>